__turbopack_context__.v({
  "checkbox": "checkbox-input-module-scss-module__q238rW__checkbox",
  "checkbox-input__loader": "checkbox-input-module-scss-module__q238rW__checkbox-input__loader",
  "checkbox__control": "checkbox-input-module-scss-module__q238rW__checkbox__control",
  "checkbox__label": "checkbox-input-module-scss-module__q238rW__checkbox__label",
  "switch": "checkbox-input-module-scss-module__q238rW__switch",
  "switch__control": "checkbox-input-module-scss-module__q238rW__switch__control",
  "switch__label": "checkbox-input-module-scss-module__q238rW__switch__label",
});
